import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { lastValueFrom, Subscription } from 'rxjs';
import { NotificationService } from '../shared/services/notification.service';
import { environment } from 'src/environments/environment';
import { AppConstants } from '../shared/constants/app.contants';
import { ApiService } from '../shared/services/api.service';
import { BaseResponseDTO } from '../core/models/app.models';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { LoaderService } from '../shared/services/loader.service';
import { UserService } from '../shared/services/user.service';

@Component({
  selector: 'app-notification-feed',
  templateUrl: './notification-feed.component.html',
  styleUrls: ['./notification-feed.component.scss']
})
export class NotificationFeedComponent implements OnInit, OnDestroy {
  isDropdownOpen: boolean = false;
  private toggleSubscription!: Subscription;
  notificationSubscription!: Subscription;

  notifications : any[] = [];
  

  constructor(
    private notificationService: NotificationService,
    private _router: Router,
    private _activeRoute : ActivatedRoute,
    private _formBuilder: FormBuilder,
    private _http: HttpClient,
    private _loaderService: LoaderService,
    private _userService: UserService,

  ) { }

  ngOnInit(): void {
    console.log('NotificationFeedComponent initialized');
    // Call GetNotifications once on init, but only if service allows it (prevents duplicate across instances)
    if (this.notificationService.canFetchNotifications()) {
      this.GetNotifictions();
    } else {
      console.log('GetNotifications skipped - another instance is fetching or too soon since last call');
    }
    
    this.toggleSubscription = this.notificationService.toggleDropdown$.subscribe(() => {
      console.log('Notification toggle triggered inside NotificationFeedComponent');
     // this.toggleNotificationDropdown();
    });
    
    // Subscribe to notifications observable for refresh triggers
    this.notificationSubscription = this.notificationService.getNotifications$.subscribe(() => {
      console.log('GetNotifications triggered via subscription');
      if (this.notificationService.canFetchNotifications()) {
        this.GetNotifictions();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.toggleSubscription) {
      this.toggleSubscription.unsubscribe();
    }
    if (this.notificationSubscription) {
      this.notificationSubscription.unsubscribe();
    }
  }

  async clearNotification(index: number,notificationId : number) {

    this._loaderService.showLoader();
    const apiService = this.createApiService();
    try {
        const response: any = await this.DeleteNotificationAPI(apiService, notificationId);
        let result = response as unknown as BaseResponseDTO;
        if (result.isSuccess) {
            // Update your notification list after a successful delete
            this.notifications = this.notifications.filter(n => n.id !== notificationId);
            console.log(`Notification with ID ${notificationId} deleted successfully.`);
        }
    } catch (err) {
        console.error('Error deleting notification', err);
    } finally {
        this._loaderService.hideLoader();
    }
  }
  
  // Method to clear all notifications
  async clearAllNotifications() {
    this._loaderService.showLoader();
    const apiService = this.createApiService();

    try {
        const response: any = await  this.DeleteAllNotificationsAPI(apiService);
        let result = response as unknown as BaseResponseDTO;

        if (result.isSuccess) {
            // Clear the notifications list after a successful delete all
            this.notifications = [];
            console.log('All notifications deleted successfully.');
        }
    } catch (err) {
        console.error('Error deleting all notifications', err);
    } finally {
        this._loaderService.hideLoader();
    }
  }

  
  

  // Toggles the dropdown when the button is clicked
  toggleNotificationDropdown(event: MouseEvent): void {
    event.stopPropagation(); // Prevent the click event from propagating to the document listener
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  // Closes the dropdown when clicking anywhere outside
  @HostListener('document:click', ['$event'])
  closeDropdownOnOutsideClick(event: MouseEvent): void {
    const targetElement = event.target as HTMLElement;

    // Check if the clicked element is not inside the dropdown or the toggle button
    if (
      !targetElement.closest('.notification-dropdown') &&
      !targetElement.closest('.nav-link')
    ) {
      this.isDropdownOpen = false;
    }
  }

      //#region API Service
      private createApiService(): ApiService {
        const apiService = new ApiService(this._http);
        apiService['_baseUrl'] = environment.API_URL; // Set the base URL manually
        return apiService;
      }
      //#endregion

      

  private async GetNotifictions() {
    this._loaderService.showLoader();
    const apiService = this.createApiService();

    this.GetNotificationsAPI(apiService)
    .then((response: any) => {
      let result = response as unknown as BaseResponseDTO;
      if(result.isSuccess) {

        this.notifications = [];
        console.log(result.data);
        // Format the date for each notification
        this.notifications = result.data.map((notification: any) => {
          const formattedDate = new Date(notification.timestamp).toLocaleString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true
          });
        
          return {
            ...notification,
            formattedTimestamp: formattedDate // Add a formatted date field
          };
          
        });

      }
    })
    .catch((err: HttpErrorResponse) => {
      this._loaderService.hideLoader();
      this.notificationService.markNotificationFetchComplete();
    })
    .finally(() => {
      this._loaderService.hideLoader();
      this.notificationService.markNotificationFetchComplete();
    });
  }



  private GetNotificationsAPI(apiService: ApiService) {
    let req$ = apiService.get(AppConstants.CONTROLLERS.notifications, AppConstants.ACTIONS.getNotifications, true, environment.APIs_PREFIX);
    return lastValueFrom(req$);
  }

// Make DeleteAllNotificationsAPI async
private async DeleteAllNotificationsAPI(apiService: ApiService): Promise<any> {
  const req$ = apiService.delete(AppConstants.CONTROLLERS.notifications, AppConstants.ACTIONS.deleteallnotifacitons, true, environment.APIs_PREFIX);
  return await lastValueFrom(req$); // Use await with lastValueFrom
}

// Make DeleteNotificationAPI async
private async DeleteNotificationAPI(apiService: ApiService, notificationId: number): Promise<any> {
  const req$ = apiService.delete(
      AppConstants.CONTROLLERS.notifications, 
      `${AppConstants.ACTIONS.deleteanotifaciton}/${notificationId}`, 
      true, 
      environment.APIs_PREFIX
  );
  return await lastValueFrom(req$); // Use await with lastValueFrom
}


}
